import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfConverter24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#F43F3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 6.583H7.467c-.747 0-1.12 0-1.405.146-.251.127-.455.331-.583.582-.146.285-.146.659-.146 1.406V12c0 .621 0 .932.102 1.177.135.327.395.586.722.721.245.102.555.102 1.176.102m4.8 5.5h4.4c.747 0 1.12 0 1.406-.145.25-.128.455-.332.582-.583.146-.285.146-.659.146-1.405v-4.4c0-.747 0-1.12-.146-1.406a1.33 1.33 0 0 0-.582-.582c-.285-.146-.659-.146-1.405-.146h-4.4c-.747 0-1.12 0-1.406.146-.25.127-.455.331-.582.582-.146.286-.146.659-.146 1.406v4.4c0 .746 0 1.12.146 1.405.127.25.331.455.582.583.285.145.659.145 1.406.145M10.667 6.583h3.69m0 0-1.94-1.666m1.94 1.666-1.94 1.667"
    />
  </svg>
);
export default SvgPdfConverter24;
